import { render, staticRenderFns } from "./roomDate.vue?vue&type=template&id=b8d9b566&scoped=true"
import script from "./roomDate.vue?vue&type=script&lang=js"
export * from "./roomDate.vue?vue&type=script&lang=js"
import style0 from "./roomDate.vue?vue&type=style&index=0&id=b8d9b566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d9b566",
  null
  
)

export default component.exports